// extracted by mini-css-extract-plugin
export default {"container":"EdYz_xXL_JJfYNtXrWZQ","heading":"esOIuJJ9UW2vIdTftw0K"};